<app-section-quick-actions section="spirit" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Special Visits</h1>
</header>

<div class="atmos-page__intro">
  <p class="atmos-paragraph atmos-page__hint">
    On this page you can find all special visits, where multiple spirits return at the same time.<br/>
    More information about these visits is available on the <a href="https://sky-children-of-the-light.fandom.com/wiki/Returning_Spirits" target="_blank" rel="noopener" class="atmos-text-link">Wiki - Returning Spirits</a> page.
  </p>
</div>

<div class="atmos-card atmos-rs__grid-card">
  <ag-grid-angular
    [rowData]="rowData"
    [columnDefs]="colDefs"
    [theme]="theme"
    [getRowHeight]="getRowHeight"
    [suppressDragLeaveHidesColumns]="true"
    (gridReady)="onGridReady($event)" />
</div>
